// Reconstructed from production code; original paths and local names were not available.
import { Helmet } from "react-helmet-async";
import { useLanguage } from "../context/LanguageContext.jsx";
import { absoluteImageUrl } from "../utils/seo.js";
import { canonicalImageUrl } from "../utils/seo.js";
import { canonicalUrl } from "../utils/seo.js";
import * as jsxRuntime from "react/jsx-runtime";
import { normalizeText } from "../utils/seo.js";
import { pageTitle } from "../utils/seo.js";
import { safeJsonLd } from "../utils/seo.js";
import { seoLocale } from "../utils/seo.js";
import { siteOrigin } from "../utils/seo.js";
function Seo({
  title: title,
  description: description,
  image: image,
  imageAlt: imageAlt,
  imageType: imageType,
  imageWidth: imageWidth,
  imageHeight: imageHeight,
  urlPath: urlPath,
  urlSearch: g = "",
  canonicalUrl: p,
  type: b = "website",
  siteName: siteName,
  siteUrl: siteUrl,
  language: H,
  locale: locale,
  noindex: M = false,
  nofollow: N = false,
  productPrice: productPrice,
  productCurrency: productCurrency,
  schema: schema,
}) {
  const { language } = useLanguage();
  const I = normalizeText(siteName || "WE IN"),
    K = siteOrigin(siteUrl),
    J = pageTitle(title, I),
    Q = normalizeText(description, 160),
    W = canonicalImageUrl(p || (urlPath ? canonicalUrl(K, urlPath, g) : ""), K),
    te = absoluteImageUrl(image, K),
    oe = seoLocale(H || language, locale),
    he = (Array.isArray(schema) ? schema : [schema]).filter(
      (R) => R && typeof R == "object",
    ),
    be = M
      ? `noindex, ${N ? "nofollow" : "follow"}`
      : `index, ${N ? "nofollow" : "follow"}, max-image-preview:large, max-snippet:-1, max-video-preview:-1`,
    fe = Number(productPrice),
    pe = b === "product" && Number.isFinite(fe) && fe > 0,
    ye = normalizeText(void 0);
  return (
    <Helmet prioritizeSeoTags={true}>
      <title>{J}</title>
      {Q && <meta name={"description"} content={Q} />}
      <meta name={"robots"} content={be} />
      <meta name={"googlebot"} content={be} />
      {W && <link rel={"canonical"} href={W} />}
      <meta property={"og:site_name"} content={I} />
      <meta property={"og:locale"} content={oe} />
      <meta property={"og:type"} content={b} />
      {W && <meta property={"og:url"} content={W} />}
      <meta property={"og:title"} content={J} />
      {Q && <meta property={"og:description"} content={Q} />}
      {te && <meta property={"og:image"} content={te} />}
      {te?.startsWith("https://") && (
        <meta property={"og:image:secure_url"} content={te} />
      )}
      {te && imageType && (
        <meta property={"og:image:type"} content={imageType} />
      )}
      {te && Number.isFinite(Number(imageWidth)) && (
        <meta property={"og:image:width"} content={String(imageWidth)} />
      )}
      {te && Number.isFinite(Number(imageHeight)) && (
        <meta property={"og:image:height"} content={String(imageHeight)} />
      )}
      {te && imageAlt && (
        <meta
          property={"og:image:alt"}
          content={normalizeText(imageAlt, 420)}
        />
      )}
      {pe && <meta property={"product:price:amount"} content={fe.toFixed(2)} />}
      {pe && productCurrency && (
        <meta
          property={"product:price:currency"}
          content={String(productCurrency).toUpperCase()}
        />
      )}
      <meta
        name={"twitter:card"}
        content={te ? "summary_large_image" : "summary"}
      />
      <meta name={"twitter:title"} content={J} />
      {Q && <meta name={"twitter:description"} content={Q} />}
      {te && <meta name={"twitter:image"} content={te} />}
      {te && imageAlt && (
        <meta
          name={"twitter:image:alt"}
          content={normalizeText(imageAlt, 420)}
        />
      )}
      {ye && <meta name={"twitter:site"} content={ye} />}
      {he.map((R, B) => (
        <script
          id={`seo-schema-${B}`}
          type={"application/ld+json"}
          dangerouslySetInnerHTML={{
            __html: safeJsonLd(R),
          }}
          key={`schema-${B}`}
        />
      ))}
    </Helmet>
  );
}
export { Seo };
